<div class="relative" *transloco="let t">
  <div class="overflow-x-hidden">
    <div
      class="inline-flex gap-xs p-[2px]"
      #metricsContainer
      [ngClass]="{'flex-wrap overflow-visible': allMetricsShown()}"
    >
      @for (m of metrics(); track m) {
        <cft-chip
          colour="grey-lighter"
          class="shrink-0 cursor-default rounded-full"
          size="sm"
          [ngClass]="{'cursor-pointer hover:outline hover:outline-grey-300': m.info}"
          (click)="showInfo($event, m.info)"
        >
          <span class="flex gap-2xs">
            @if (isIconComponent(m.icon)) {
              <ng-container *ngComponentOutlet="m.icon.component; inputs: m.icon.inputs" />
            } @else if (m.icon) {
              <fa-icon [icon]="m.icon"></fa-icon>
            }
            <span>{{ t(m.label.localizedValue, m.label.params) }}</span>
            @if (m.suffix) {
              @if (isIconComponent(m.suffix.icon)) {
                <ng-container *ngComponentOutlet="m.suffix.icon.component; inputs: m.suffix.icon.inputs" />
              } @else if (m.suffix.icon) {
                <fa-icon [icon]="m.suffix.icon"></fa-icon>
              }
              <span>{{ m.suffix.value }}</span>
            }
          </span>
        </cft-chip>
      }
      @if (allMetricsShown()) {
        <cft-chip
          class="rounded-full hover:bg-grey-100"
          size="sm"
          colour="white"
          (click)="toggleShowAllMetrics($event)"
        >
          <span class="flex gap-xs">
            <span>{{ t('proDirectoryCard.lessMetricsLabel') }}</span>
            <fa-icon [icon]="moreOrLessIcon"></fa-icon>
          </span>
        </cft-chip>
      }
    </div>
  </div>
  @if (metricsContainerWidth() >= parentContainerWidth() && !allMetricsShown()) {
    <cft-chip
      class="absolute top-0 right-0 mt-[2px] -mr-2 cursor-pointer rounded-full hover:bg-grey-100"
      size="sm"
      colour="white"
      (click)="toggleShowAllMetrics($event)"
    >
      <span class="flex gap-xs">
        <span>{{ t('proDirectoryCard.moreMetricsLabel') }}</span>
        <fa-icon [icon]="moreOrLessIcon"></fa-icon>
      </span>
    </cft-chip>
  }
</div>
